<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex md6 xs12>
        <v-card>
          <v-card-title primary-title>
            <span class="headline mb-0">ユーザーマスタ</span>
          </v-card-title>
          <v-card-actions>
            <v-btn
              :disabled="!employee.valid"
              @click="save"
              v-permit.SHARP_UAS_NEW
              >{{ $t('app.buttons.save') }}</v-btn
            >
            <v-btn
              @click="remove"
              v-if="$route.query.id"
              v-permit.SHARP_UAS_DELETE
              >{{ $t('app.buttons.remove') }}</v-btn
            >
            <v-btn @click="returnToList()">{{ $t('app.buttons.back') }}</v-btn>
            <v-avatar />
            <v-avatar />
            <v-avatar />
            <v-btn
              :disabled="!hasDownload"
              @click="download"
              v-permit.SHARP_UAD_DOWNLOAD
              >申込書Download</v-btn
            >
          </v-card-actions>
          <label-card :employee="employee" />
        </v-card>
      </v-flex>
      <v-flex md6 pl-1 pr-1 v-if="employee.username" xs12>
        <v-card>
          <v-card-title>
            <span class="headline mb-0">権限</span>
          </v-card-title>
          <v-card-actions>
            <v-btn @click="$refs.rightListDlg.popup()" v-permit.SHARP_UAD_ADD>{{
              $t('app.buttons.add')
            }}</v-btn>
            <v-btn @click="removeRoles" v-permit.SHARP_UAD_DELETE>{{
              $t('app.buttons.remove')
            }}</v-btn>
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :items="userRoles"
            :rows-per-page-items="[10]"
            class="elevation-0"
            hide-actions
            item-key="roleId"
            select-all
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>
                {{ props.item.roleCode }}
                <!-- <router-link
                  :to="{ name: 'EditM0021', params: { id: props.item.roleCode }}"
                >{{ props.item.roleCode }}</router-link>-->
              </td>
              <td>{{ props.item.roleName }}</td>
            </template>
          </v-data-table>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline mb-0">閲覧許可口座</span>
          </v-card-title>
          <v-card-actions>
            <v-select
              label="バイヤーコード"
              :items="buyers"
              v-model="buyer"
              append-outer-icon="add"
              @click:append-outer="addbuyerCode"
              item-text="code"
              return-object
              clearable
            >
            </v-select>
            <v-checkbox
              v-model="viewAll"
              label="すべてのデータを表示"
            ></v-checkbox>
          </v-card-actions>
          <div class="chip-wrap">
            <v-chip
              @input="closeBuyer(item)"
              v-for="item in employee.buyers"
              :key="item.value"
              class="ma-2"
              close
              color="orange"
              outline
            >
              {{ item.text }}
            </v-chip>
          </div>
        </v-card>
      </v-flex>
    </v-layout>

    <list-dialog @submit="addRoles" ref="rightListDlg"></list-dialog>
  </v-container>
</template>

<script>
import ListDialog from './ListDialog'
import LabelCard from './LabelCard'
import md5 from 'md5'

export default {
  components: {
    ListDialog,
    LabelCard,
  },
  data() {
    return {
      buyers: [],
      viewAll: false,
      buyer: null,
      employee: {
        loginRefused: true,
        roles: '',
        endDate: '2050-01-01',
        buId: null,
        companyId: null,
        username: null,
        companyType: 'SJL',
        buyers: [],
      },
      roles: [],
      userRoles: [],
      files: [],
      headers: [
        {
          text: '権限グループCD',
          value: 'roleCode',
          sortable: false,
        },
        {
          text: '権限グループ名',
          value: 'roleCode_local',
          sortable: false,
        },
      ],
      selected: [],
      showDialog: false,
      initPwd: '',
      errors: {
        EMAIL_EXISTS: 'EMAILは既に使用されています。',
        USERNAME_EXISTS: 'USERNAMEは既に存在しています。',
        CODE_EXISTS: 'CODEは既に存在しています。',
      },
    }
  },
  methods: {
    returnToList() {
      this.$router.push({
        name: 'M0010',
      })
    },
    removeRoles() {
      this.userRoles = this.userRoles.filter(
        (r) => this.selected.indexOf(r) === -1
      )
      this.selected = []
    },
    createUserAccount() {
      return this.$http
        .post(`/auth-service/auth/create-user`, {
          password: this.employee.initPwd,
          realName: this.employee.showName,
          username: this.employee.username,
          roleIds: this.userRoles.map((r) => r.roleId),
          effective: this.employee.startDate,
          language: this.employee.language,
          expire: this.employee.endDate,
          userStatus: !!this.employee.loginRefused ? 'DISABLE' : 'ENABLE',
        })
        .then((res) => {
          console.log(res)
          if (res.data.success) {
            this.employee.userAccountId = res.data.data[0].userId
            this.employee.userIdentityId = res.data.data[0].userIdentityId
            return this.employee
          } else {
            return Promise.reject(res)
          }
        })
    },
    updateUserAccount() {
      return this.$http
        .put(`/auth-service/auth/modify-user`, {
          realName: this.employee.showName,
          username: this.employee.username,
          userId: this.employee.userAccountId,
          language: this.employee.language,
          userIdentityId: this.employee.userIdentityId,
          roleIds: this.userRoles.map((r) => r.roleId),
          effective: this.employee.startDate,
          expire: this.employee.endDate,
          userStatus: !!this.employee.loginRefused ? 'DISABLE' : 'ENABLE',
        })
        .then((res) => {
          console.log(res)
          if (res.data.success) {
            return this.employee
          } else {
            return Promise.reject(res)
          }
        })
    },
    saveUserAccount() {
      if (!this.employee.userAccountId) {
        return this.createUserAccount()
      } else {
        return this.updateUserAccount()
      }
    },
    saveEmployee() {
      if (this.employee.buyers.length > 0) {
        this.employee.tdocDataAuthorities = this.employee.buyers
          .map((b) => b.text)
          .join(',')
      } else {
        this.employee.tdocDataAuthorities = null
      }
      this.employee.roles = this.userRoles.map((r) => r.roleCode).join()
      return this.$http
        .post('/employees', {
          ...this.employee,
          initPwd: this.initPwd,
        })
        .then((res) => {
          this.$message(
            this.$t('app.messages.success.title'),
            this.$t('app.messages.saveSuccess')
          )
          this.$router.push({
            name: 'M0011Edit',
            query: {
              id: res.data.id,
            },
          })
          return res.data
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    save() {
      this.saveEmployee().then((res) => {
        this.employee.username = res.username
      })
    },
    addRoles(roles) {
      let addRoles = roles.filter(
        (r) => !this.userRoles.find((rs) => rs.roleId === r.roleId)
      )
      this.userRoles = [...this.userRoles, ...addRoles]
    },
    download() {
      if (this.files && this.employee.email) {
        let file = this.files.sort((a, b) => {
          return b.uploadDate - a.uploadDate
        })[0]
        this.$download(`/files/users/${this.employee.email}/files/${file.id}`)
      }
    },
    addbuyerCode() {
      if (
        this.employee.buyers.filter((v) => v.value === this.buyer.code)
          .length === 0
      ) {
        this.employee.buyers.push({
          text: this.buyer.code + ':' + this.buyer.name,
          value: this.buyer.code,
        })
        this.$forceUpdate()
      } else {
        this.$message('', '已存在')
      }
    },
    closeBuyer(item) {
      this.employee.buyers.forEach((b, index) => {
        if (b.value === item.value) {
          this.employee.buyers.splice(index, 1)
          this.$forceUpdate()
        }
      })
    },
    getAllBuyers() {
      this.$http
        .get(`/buyers/company/${this.employee.companyId}/code`)
        .then((res) => {
          this.buyers = res.data
        })
    },
    setAllBuyers() {
      this.employee.buyers = [
        ...this.buyers.map((b) => {
          return {
            text: b.code + ':' + b.name,
            value: b.code,
          }
        }),
      ]
    },
    clearBuyers() {
      this.employee.buyers = []
    },
  },
  computed: {
    hasDownload() {
      return this.files.length > 0
    },
  },
  mounted() {
    // this.$refs.rightListDlg.loadRoles().then((res) => {
    //   this.roles = res
    // })
    // this.userRoles = JSON.parse(localStorage.getItem('user')).roles
    this.initPwd = this.$getRandomPwd(8)
  },
  watch: {
    viewAll() {
      if (this.viewAll) {
        this.setAllBuyers()
      } else {
        // this.clearBuyers()
      }
    },
    'employee.companyId'() {
      this.getAllBuyers()
    },
  },
}
</script>

<style>
.btn {
  position: absolute;
  right: 200px;
  top: 0px;
}
</style>
